import { render, staticRenderFns } from "./suggestDialog.vue?vue&type=template&id=381e6230&scoped=true&"
import script from "./suggestDialog.vue?vue&type=script&lang=js&"
export * from "./suggestDialog.vue?vue&type=script&lang=js&"
import style0 from "./suggestDialog.vue?vue&type=style&index=0&id=381e6230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e6230",
  null
  
)

export default component.exports